$(function() {
  // init
  if($('.js-prodImgCarousel').length) {
    $('.js-prodImgCarousel').each(function(){
      var $mainStageItem = $(this).find('.js-prodImgCarouselMainStage .item');
      var $thumbItem = $(this).find('.js-prodImgCarouselThumbList .item');
      $mainStageItem.hide;
      if($mainStageItem.hasClass('isSelect')) {
        var index = $(this).find('.js-prodImgCarouselMainStage .item.isSelect').index();
        $(this).find('.js-prodImgCarouselThumbList .item').eq(index).addClass('isSelect')
      } else {
        $mainStageItem.first().addClass('isSelect');
        $thumbItem.first().addClass('isSelect');
      }
    });
  }

  // thumbnail click
  $('.js-prodImgCarouselThumbList .item').on('click',function(){
    if($(this).hasClass('isSelect')) {
      return false;
    } else {
      $(this).parent().prev('.js-prodImgCarouselMainStage').find('.item').removeClass('isSelect');
      $(this).closest('.js-prodImgCarouselThumbList').find('.item').removeClass('isSelect');
      $(this).addClass('isSelect');
      var index = $(this).index();
      $(this).parent().prev('.js-prodImgCarouselMainStage').find('.item').eq(index).addClass('isSelect')
    }
  });
});